import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSdCard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sd-card, memory-stick"} maskId="square-filled-radius-0-stroke-1-IconSdCard"><path fillRule="evenodd" clipRule="evenodd" d="M4 2V22H20V10.8585L18 7.60848V2H4ZM10 6V10H9V6H10ZM13 6H12V10H13V6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSdCard;
